import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ServiziHero from './components/ServiziHero';
import ServiziList, { services } from './components/ServiziList';
import ServiziStats from './components/ServiziStats';
import ServiziFAQ, { faqItems } from './components/ServiziFAQ';

const SITE_URL = 'https://ngprenovatieprojecten.com';

const ServiziPage = () => {
  useEffect(() => {
    // Schema.org: WebPage
    const webPageSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Diensten – NGP Renovatieproject Antwerpen',
      description:
        'Professionele renovatiediensten in Antwerpen: badkamer verbouwing, keuken renovatie en volledige appartement renovatie door NGP Renovatieproject.',
      url: `${SITE_URL}/diensten`,
      inLanguage: 'nl-BE',
      publisher: {
        '@type': 'LocalBusiness',
        name: 'NGP Renovatieproject',
        url: SITE_URL,
        telephone: '+32460940222',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Adelaarstraat 55 B301',
          addressLocality: 'Merksem',
          postalCode: '2170',
          addressCountry: 'BE',
        },
      },
    };

    // Schema.org: Service per ogni tipo di renovatie
    const serviceSchemas = services.map((s) => ({
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: s.schemaName,
      description: s.schemaDescription,
      url: `${SITE_URL}/diensten#${s.id}`,
      serviceType: s.tag,
      areaServed: {
        '@type': 'City',
        name: 'Antwerpen',
        sameAs: 'https://www.wikidata.org/wiki/Q12892',
      },
      provider: {
        '@type': 'LocalBusiness',
        name: 'NGP Renovatieproject',
        url: SITE_URL,
        telephone: '+32460940222',
        email: 'ngp.renovatieprojecten@gmail.com',
        vatID: 'BE1023188662',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Adelaarstraat 55 B301',
          addressLocality: 'Merksem',
          postalCode: '2170',
          addressCountry: 'BE',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 51.2397,
          longitude: 4.4297,
        },
        sameAs: [
          'https://www.instagram.com/ngp.renovatieprojecten',
          'https://www.facebook.com/profile.php?id=61582254384826',
        ],
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: s.schemaName,
        itemListElement: s.features.map((feat, i) => ({
          '@type': 'Offer',
          position: i + 1,
          itemOffered: {
            '@type': 'Service',
            name: feat,
          },
        })),
      },
    }));

    // Schema.org: FAQPage
    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqItems.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer,
        },
      })),
    };

    // Inject all schemas
    const allSchemas = [webPageSchema, ...serviceSchemas, faqSchema];
    const existingScripts = document.querySelectorAll('script[data-schema="servizi"]');
    existingScripts.forEach((s) => s.remove());

    allSchemas.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'servizi');
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    // Update page title & meta
    document.title = 'Diensten Renovatie Antwerpen | Badkamer, Keuken, Appartement – NGP';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'NGP Renovatieproject biedt professionele renovatiediensten in Antwerpen: badkamer verbouwing, keuken renovatie en volledige appartement renovatie. Vraag een gratis offerte aan.'
      );
    }

    return () => {
      document.querySelectorAll('script[data-schema="servizi"]').forEach((s) => s.remove());
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <ServiziHero />
        <ServiziList />
        <ServiziStats />
        <ServiziFAQ />
      </main>
      <Footer />
    </div>
  );
};

export default ServiziPage;
